
<template>
  <div class="photo">

    <!-- Loading Animation START -->
    <div v-if="busy" class="full-box">
      <div class="loadingWorkOrders">
        <div class="logo"></div>
        <div class="loading-image"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"></i></div>
        Loading Photos for Work Order #{{this.$route.params.id}}        
      </div>
    </div>
    <!-- Loading Animation END -->

    <!-- Mobile Menu START -->
    <template v-if="openMenu">
      <div class="overlay">
        <div class="mobile-menu">
          <div class="inner">
            <div v-on:click="hideMenu()" class="close-menu"><i class="fa fa-times" aria-hidden="true"></i></div>
            <h2>{{username}}</h2>
            <ul>
              <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
              <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
            </ul>
            <br><br>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Menu END -->

    <!-- Main Header START -->
    <div class="main-header">

      <div class="top">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">

            <!-- Tablet Header START -->
            <div v-if="$mq.resize && $mq.above($mv.tablet)">
              <button v-on:click="goBackToWO()" class="pull-right btn header-btn mcBG scBGHover"><i class="fa fa-reply" aria-hidden="true"></i> Back to the Work Order</button>
            </div>
            <!-- Tablet Header END -->

            <!-- Mobile Header START -->
            <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
              <ul>
                <li v-on:click="goBackToWO()"><i class="fa fa-reply" aria-hidden="true"></i></li>
                <li v-on:click="showMenu()"><i class="fa fa-bars" aria-hidden="true"></i></li>
              </ul>
            </div>
            <!-- Mobile Header END -->
              
            <div class="logo"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main Header END -->

    <!-- Header Bar START -->
    <div class="inner-header-bar mcBG">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <img src="static/img/i3v_icon_white.png" class="pull-right">
              <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
                <h1>Add Photos <span>[WO# {{workOrder}}]</span> </h1>
              </div>
              <div v-if="$mq.resize && $mq.above($mv.tablet)">
                <h1>Add Photos - WO# {{workOrder}} </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header Bar END -->

    <!-- Main Tablet View START -->
    <div v-if="$mq.resize && $mq.above($mv.tablet)" class="tablet-view">
      <div class="container">
        
        <div class="row flexrow">

          <!-- First Column START -> col-sm-5 -->
          <div class="col-sm-9">
            <div class="inner">

            <!-- If WO is Complete -> Show Completed Message -->
            <template v-if="workOrderCheck.fieldComplete">
              <h2>Work Order is closed</h2>
              <div class="form-group">
                <p>This Work Order is closed, so you will not be able to add any new <strong>photos</strong> or delete any existing photos.</p>
              </div>
            </template>

            <!-- If WO is NOT Complete -> Show Form to Add/Edit Material Entries -->
            <template v-if="!workOrderCheck.fieldComplete">
              
              <h2>{{leftTitle}}</h2>

              <div v-if="canTakePics">
              <!-- If user can take pictures -->

                <div class="form-group">
                    <label for="fileInput">Select Photo</label>
                    <image-uploader
                      :debug="2"
                      :maxWidth="1024"
                      :maxHeight="1024"
                      :quality="0.9"
                      :autoRotate=false
                      outputFormat="string"
                      :preview=true
                      :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                      @input="setImage"
                      @onUpload="startImageResize"
                      @onComplete="endImageResize"
                    ></image-uploader>           
                  </div>    

                 <!-- Action Buttons -->
                <div class="form-group">
                  <button v-show="showPhotoSave" v-on:click="submitForm" type="button" class="mcBG scBGHover btn btn-primary">{{buttonTitle}}</button> 
                </div>
                

                 <!-- Loading Messages for Adding New Record/Editing Existing Record -->
                <div class="statusMSG form-group" v-show="busyUploading">
                  Uploading & Optimizing Photo <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                </div>
                <div class="statusMSG form-group" v-show="busySaving">
                  Saving New Photo to the Database <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                </div>

                <!-- Error Message Holder -->
                 <div v-show="submitError" class="form-group">
                  <div class="error">
                    {{submitErrorText}}
                  </div>  
                </div>

              </div>


              <div v-if="!canTakePics">
                <div class="form-group">
                <p>Your user cannot upload new photos to this Work Order.</p></div>
              </div>

              </template>

            </div>
          </div> 
          <!-- First Column END -> col-sm-5 -->

          <!-- 
              Gallery for Existing Photos (TBD). 
                                                  -->

          <!-- Second Column START -> col-sm-4 -->
          <!-- <div class="col-sm-4">
            <div class="inner">
              <h2>Existing Photos</h2>

              <div class="statusMSG form-group" v-show="busyDel">
                Deleting Photo <i class="fa fa-refresh fa-spin" aria-hidden="true"></i></span>
              </div>

              <ul class="innerWOListing">
                <li v-for="photoRecord in orderBy(photoRecords, 'CreatedOn', -1)">


                  <lightbox
                    :thumbnail="photoRecord.fullURL"
                    :images="[photoRecord.fullURL]"
                  ></lightbox>

                     <img v-bind:src="photoRecord.fullURL" class="img-responsive">

                     <div class="pull-right"><strong>Date:</strong> {{photoRecord.CreatedOn | moment("MMM Do, YYYY ") }}</div>
                     
                     <div v-if="canDelPics">
                     <div v-if="!workOrderCheck.fieldComplete">
                        <div class="btn del-btn mcBG scBGHover" v-on:click="del(photoRecord.lineId,photoRecord.fullURL)"><i class="fa fa-times mcTextHover" aria-hidden="true"></i> Delete Photo</div>
                      </div>
                    </div>
                </li>
              </ul>

            </div>
          </div> -->
          <!-- Second Column END -> col-sm-4 -->

          <!-- Third Column START -> col-sm-3 -->
          <div class="col-sm-3">
            <div class="inner-dark">
              <h3 class="mcText"><span>Username</span>
              {{username}}</h3>
              <ul>
                <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
                <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
              </ul><br><br>
            </div>
          </div>
          <!-- Third Column END -> col-sm-3 -->

        </div>
      </div>
    </div> 
    <!-- Main Tablet View END -->

    <!-- Main Mobile View START -->
    <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
      <div class="mobile-view">

        <!-- Mobile Top Section START -->
        <div class="lem-formTop">

          <!-- If WO is Complete -> Show Completed Message -->
          <template v-if="workOrderCheck.fieldComplete">
            <h2>Work Order is closed</h2>
            <div class="form-group">
              <p>This Work Order is closed, so you will not be able to add any new <strong>photos</strong> or delete any existing photos.</p>
            </div>
          </template>

          <!-- If WO is NOT Complete -> Show Form to Add/Edit Material Entries -->
          <template v-if="!workOrderCheck.fieldComplete">
            <h2>{{leftTitle}}</h2>

            <div v-if="canTakePics">
            <!-- If user can take pictures -->

              <div class="form-group">
                      <label for="fileInput">Select Photo</label>
                      <image-uploader
                        :debug="2"
                        :maxWidth="1024"
                        :maxHeight="1024"
                        :quality="0.9"
                        :autoRotate=false
                        outputFormat="string"
                        :preview=true
                        :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                        @input="setImage"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                      ></image-uploader>           
                    </div>    

                   <!-- Action Buttons -->
                  <div class="form-group">
                    <button v-show="showPhotoSave" v-on:click="submitForm" type="button" class="mcBG scBGHover btn btn-primary">{{buttonTitle}}</button> 
                  </div>

                   <!-- Loading Messages for Adding New Record/Editing Existing Record -->
                  <div class="statusMSG form-group" v-show="busyUploading">
                    <span>Uploading & Optimizing Photo <i class="fa fa-refresh fa-spin" aria-hidden="true"></i></span>
                  </div>
                  <div class="statusMSG form-group" v-show="busySaving">
                    <span>Saving New Photo to the Database <i class="fa fa-refresh fa-spin" aria-hidden="true"></i></span>
                  </div>

           </div>

           <div v-if="!canTakePics">
            <!-- If user can take pictures -->
              <div class="form-group">
                <p>Your user cannot upload new photos to this Work Order.</p>
              </div>
            </div>


          </template>
        </div>
        <!-- Mobile Top Section END -->

        <!-- Mobile Middle Info START -->
        <div class="lem-dividingCount">
          {{ photoRecords.length }} Records
        </div>
        <!-- Mobile Middle Info END -->

        <!-- Mobile Listing START -->
        <div class="lem-listingBottom">
            
            <!-- Loading Messages for Deleting an Existing Record -->
            <div class="statusMSG form-group" v-show="busyDel">
              <span>Deleting Photo <i class="fa fa-refresh fa-spin" aria-hidden="true"></i></span>
            </div>

              <!-- Gallery of existing Photo Records (TBD) -->
             <!-- <ul class="innerWOListing">
                <li v-for="photoRecord in orderBy(photoRecords, 'CreatedOn', -1)">
                  

                  <div v-if="!workOrderCheck.fieldComplete">
                    
                  </div>
                  
                  <lightbox :thumbnail="photoRecord.presignedUrl" :images="[photoRecord.presignedUrl]"></lightbox>

                     <img v-bind:src="photoRecord.presignedUrl" class="img-responsive">

                     <div class="pull-right"><strong>Date:</strong> {{photoRecord.CreatedOn | moment("MMM Do, YYYY ") }}</div>
                     <div v-if="canDelPics">
                          <div v-if="!workOrderCheck.fieldComplete">
                              <div class="btn del-btn mcBG scBGHover" v-on:click="del(photoRecord.lineId, photoRecord.presignedUrl)"><i class="fa fa-times mcTextHover" aria-hidden="true"></i> Delete Photo</div>
                          </div>
                     </div>
               
                </li>
              </ul> -->
        </div>
        <!-- Mobile Listing END -->
      </div>    
    </div>
    <!-- Main Mobile View END --> 

    <!-- Debug DATA START -->
    <pre v-show="false">
      {{ $data }}
    </pre>
    <!-- Debug DATA END -->
    
  </div> <!-- </material> -->
</template>

<script>
import Store from '../store'
import User from '../services/user'
import Datepicker from 'vuejs-datepicker'
import CryptoJS from 'crypto-js'
import { ImageUploader } from 'vue-image-upload-resize'
import dataURLtoBlob from 'blueimp-canvas-to-blob'
import { getRandomKey, getPhoto, getWorkOrder, postPhotoRecord, deletePhotoRecord } from '../services/requests'

export default {
  name: 'photos',

  created() {

    // Loading Message True
    this.busy = true

    // Initial WO number
    this.workOrder = this.$route.params.id

    // Username to display on Mobile Menu/Third Column
    this.username = User.getUsername()

    // Grab Random Key name for file
    getRandomKey()
      .toArray((randomKey) => {
        this.randomFileName = randomKey[0].fileName
        this.randomFileName = this.randomFileName + '.jpg';
      }
    )

    // Grab WO information (for checking if WO is closed or not)
    getWorkOrder(this.$route.params.id)
      .toArray((workOrders) => {
        this.workOrderCheck = workOrders[0]
      }
    )

     getPhoto(this.workOrder)
      .toArray((photoRecords) => {
        this.photoRecords = photoRecords
        this.busy = false
      })

    
   

  },
  methods: {

submitForm() {

    // Show saving Animatino
    this.busySaving = true;
    // Each image to have its own Id for payload POST.
    this.imageId = this.imageId + 1;

    function getBase64Image(dataURI) {
        return dataURI.split(',')[1];
    }

    // Convert current image to raw binary data
    let imageInBase64 = getBase64Image(this.image);

    // Save to DB
    let now = new Date()

    let record = {
      uRecId: '',   
      systemCode: User.getSystemCode(),
      fileName: this.randomFileName,
      woNumber: this.workOrder,
      lineId: this.imageId,       
      rawMIMEType: 'image/jpeg',
      encodedData: imageInBase64,
      createdOn: now.toISOString(),
      updatedOn: now.toISOString(),
    }


    postPhotoRecord(this.workOrder, record)
        .stopOnError((err) => {
          
          var errorArray = JSON.parse(err.message)
          this.errorArray = errorArray
          alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)
          
          this.busySaving = false;
        })
        .done(() => {

          document.getElementById("fileInput").value = "";
          // document.getElementsByClassName("img-preview")[0].style.display='none';

          getPhoto(this.workOrder)
          .toArray((photoRecords) => {
            this.photoRecords = photoRecords

            // Will be able to complete the Gallery here.

                // getRandomKey()
                //   .toArray((randomKey) => {
                //     this.randomFileName = randomKey[0].fileName
                //     this.randomFileName = this.randomFileName + '.jpg'
                //   }
                // )

              this.showPhotoSave = false
              this.busySaving = false;
          })
           
        })

},



    startImageResize() {
      this.busyUploading = true
    },

    setImage: function (file) {
      this.hasImage = true
      this.image = file
    },

    endImageResize() {
       this.busyUploading = false
       this.showPhotoSave = true
    },

     backToListings() {
      this.$router.push('/')
    },

    // Menu link to get back to the WO
    goBackToWO() {
      this.$router.replace('/workorder/' + this.workOrder)
    }, 

    // Main Method to Log Out
    logout() {
      User.logout()
      this.$router.replace('/login')
      alert('You have succesfully logged out!')
    },

    // Show/Hide Mobile Menus
    showMenu() {
      this.openMenu = true;
    },
    hideMenu() {
      this.openMenu = false;
    },

  




    // del(lineId,fullURL) {
      
  
    //   this.busyDel = true
    //   this.delKey = fullURL.replace('https://s3.us-east-1.amazonaws.com/umm-prod-usa-va/', '');

    //   AWS.config.update({
    //       accessKeyId : 'AKIAJUCRBPCVPXUQRPMA',
    //       secretAccessKey : 'CFzrT70SR9mq1zgZV+oWVPP+TQQRWNHcTxforNdf'
    //   }),
    //   AWS.config.region = 'us-east-1', // ex: ap-southeast-1

    //   this.bucketInstance = new AWS.S3()
    //   this.params = {
    //       Bucket: 'umm-prod-usa-va',
    //       Key: this.delKey
    //   };
    //   this.bucketInstance.deleteObject(this.params, function (err, data) {
    //       if (data) {
    //           console.log("File deleted successfully from S3");
    //       }
    //       else {
    //           console.log("Check if you have sufficient permissions : "+err);
    //       }
    //   });


    //   let record = {
    //     systemCode: User.getSystemCode(),
    //     woNumber: this.workOrder,
    //     lineId: lineId,
    //   }

    //   deletePhotoRecord(this.workOrder, record)
    //     .stopOnError((err) => {
          
    //       var errorArray = JSON.parse(err.message)
    //       this.errorArray = errorArray
    //       alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)

    //       this.busyDel = false
    //     })
    //     .done(() => {

    //       getPhoto(this.workOrder)
    //       .toArray((photoRecords) => {
    //         this.photoRecords = photoRecords

    //          this.busyDel = false
    //       })
           

    //   }) // deletePhotoRecord END

    // },

  },
  components: {
    ImageUploader,
    dataURLtoBlob
  },
  data () {
    return {
      photoRecords: [],
      fullSavedFileURL: '',
      busySaving: false,
      showPhotoSave: false,
      busyUploading: false,
      randomFileName: '',
      hasImage: false,
      image: '',
      record: [],
      workOrderCheck: [],
      openMenu: false,
      busy: true,
      leftTitle: 'Upload A New Photo',
      buttonTitle: 'Save',
      editing: false,
      bucketInstance: '',
      params: [],
      busyDel: false,
      busySave: false,
      busyEdit: false,
      editingRow: '',
      time: '',
      workOrder: '',
      imageId: 0,
      canTakePics: true, // Hard-code to true for now.
      canDelPics: false, // Hard-code to false until delete func /client.js switch is available. 
    }
  }
}
</script>

<style scoped>
.photo {
 padding-top: 102px;
  position: relative;
}

.mobileBottomBar {
  display: none;
}

  .photo .main-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
    padding: 0;
  }

.photo .main-header .top {
  background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  }

  .photo .header-btn {
    color: #fff;
    font-family: 'open_sanssemibold';
    font-size: 12px;
    margin-left: 10px;
  }

    .photo .header-btn i {
      margin-right: 5px;
    }

    .tablet-view {
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .tablet-view .form-group {
      padding: 0 20px;
      margin: 15px 0;
    }

    .tablet-view .form-group .form-control {
      background: #eef2f4;
      font-size: 13px;
      color: #666;
    }

     .tablet-view .datepicker input {
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
        color: #555;
        display: block;
        font-size: 14px;
        height: 34px;
        line-height: 1.42857;
        padding: 6px 12px;
        transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
        width: 100% !important;
        background: #eef2f4;
        font-size: 13px;
        color: #666;
     }

    .tablet-view .form-group .btn {
      color: #fff;
      border: 0;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
        margin: 0 auto;
        display: block;
    }

    .tablet-view .form-group strong span {
      cursor: pointer;
    }

.innerWOListing,
.innerWOListing li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.innerWOListing li {
  padding: 12px;
  color: #010101;
}

.innerWOListing li:nth-of-type(even) {
  background: #f9f9f9;
}



.innerWOListing .del-btn {
  color: #fff;
  padding: 2px 6px;
  font-size: 12px;
}

.innerWOListing li strong {
  display: inline-block;
  font-family: 'open_sansbold';
  font-weight: normal;
  text-transform: uppercase;
}

.innerWOActions,
.innerWOActions li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

  .innerWOActions {
    margin-bottom: 40px;
    }

  .innerWOActions li {
    padding: 15px 10px 15px 20px;
    font-size: 18px;
    color: #010101;
    cursor: pointer;
  }

  .innerWOActions li i {
    color: #666;
    margin-right: 10px;
  }

  .innerWOActions li:nth-of-type(even) {
    background: #f3fbff;
  }

.innerWOListing li .actions {
  float: right;
  font-size: 21px;
}

.innerWOListing li.mcBGactive {
    display: block;      
    color: #fff !important;
  }     

.innerWOListing li.mcBGactive i {
    color: #fff !important;
  }

@media only screen and (max-width : 768px) {

.photo input[type="file"] {
  text-align: center;
  margin: 0 auto;
}

  .innerWOtopRow {
    text-align: center;
  }

  .innerWOtopRow .row {
    display: flex;
    font-size: 17px;
  font-family: 'open_sanssemibold';
  }

  .innerWOtopRow .left {
    background: #e7e7e7;
    border-bottom: #d4d1d1 solid 4px;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .innerWOtopRow .right {
    padding-top: 30px;
    padding-bottom: 30px;
  } 

  .innerWOtopRow h5 {
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
  margin: 0;
  padding: 0 0 5px 0;
  }

  .innerWOtopRow .right h5 {
    color: #e9e9e9;
    }

   .innerWOmainListing {
     margin: 20px 0px;
     text-align: center;
     font-size: 14px;
   } 

   .innerWOmainListing p {
    margin: 0 0 3px;
    padding: 0 5px;
   }

   .innerWOmainListing strong {
   font-weight: normal;
   font-family: 'open_sanssemibold';
   }

   .innerWOmainListing p.priorityHigh {
    background: #cc0000;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWOmainListing p.priorityMedium {
      background: #ff9900;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWOmainListing p.priorityScheduled {
      background: #66cc00;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWoCompletion {
    background: #f8f8f8;
    padding: 25px;
   }


    .innerWoCompletion .form-group .form-control {
      background: #eef2f4;
      font-size: 13px;
      color: #666;
    }

    .innerWoCompletion .form-group .btn {
      color: #fff;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
        margin: 0 auto;
        display: block;
    }
  
}









.loadingWorkOrders {
  text-align: center;
  font-size: 17px;
  font-family: 'open_sanssemibold';
  padding-top: 20px;
}

  .loadingWorkOrders img {
    display: block;
    margin: 0 auto 10px;
  }


  #woListing {
    width: 100%;
  }

  #woListing ul,
  #woListing ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
  }

    #woListing ul li {
      padding: 10px 0 10px 50px;
      background-image: url(../../static/img/icon-wo-open.png);
      background-repeat: no-repeat;
      background-position: 15px center;    
      cursor: pointer;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900;
    }

    #woListing ul li .woTopRow {
      font-size: 16px;
    }

    #woListing ul li:nth-child(odd) {
      background-color: #eaeaea;
    }

     #woListing ul li strong {
     font-weight: normal;
     font-family: 'open_sansbold';
     }

      #woListing ul li img {
        padding-top: 30px;
      }

.tablet-view {
  background: #f5f8fb;
}

.flexrow {
  display: flex;
}

  .tablet-view .tabletSortSearchRow {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 12px; 
    font-family: 'open_sanssemibold';
  }

    .tablet-view .tabletSortSearchRow a {
      display: inline-block;
      margin: 0 0 5px;
      padding: 3px 10px;
      text-decoration: none;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    .tablet-view .tabletSortSearchRow a.active {
      color: #fff;
    }

    .tablet-view .tabletSortSearchRow .form-control {
      max-width: 70%;
      display: inline-block;
      margin-left: 10px;
      height: 26px;
      font-size: 12px;
      background-color: #e7edf2;
      border: 0;
    }

    .tablet-view .tabletSortSearchRow .btn {
      max-width: 10%;
      color: #fff;
    }

    .tablet-view .inner {
       background: #fff;
       min-height: 100%;
    }

    .tablet-view .inner-dark {
      background: #212121;
      color: #fff;
      padding: 5px;
      text-align: center;
      min-height: 100%;
    }

      .tablet-view .inner-dark h3 {
        border-top: #555 solid 2px;
        border-bottom: #555 solid 2px;
        padding: 10px 0;
        margin: 0;
        font-size: 16px;
        color: #00b7e3;
         font-family: 'open_sanssemibold';
      }

      .tablet-view .inner-dark h3 span {
        font-size: 11px;
        text-transform: uppercase;
        color: #777;
        display: block;
        margin-bottom: 5px;
      }

      .tablet-view .inner-dark ul,
      .tablet-view .inner-dark ul li {
        margin: 0;
        padding: 0;
        list-style-type: none;
        text-align: right;
      }

       .tablet-view .inner-dark ul {
        padding-right: 20px;
        padding-top: 10px;
       }

        .tablet-view .inner-dark ul li {
          color: #fff;
          padding: 10px 0;
          cursor: pointer;
        }

        .tablet-view .inner-dark ul li i {
          margin-left: 5px;
          color: #999;
        }

    .tablet-view h2 {
      margin: 0;
      padding: 20px;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .tablet-view .completedtrue {
      border: 0 !important;
      background-image: none !important;
      padding: 10px 0 10px 10px !important;
    }

    .tablet-view .completedtrue:nth-child(odd) {
      background-color: #f3fbff !important;
    }

.mobile-view .completedtrue {
  background: #333 !important;
  color: #ccc;
  border-bottom: 1px dotted #666;
}
    .mobile-view .completedtrue .woTopRow {
      color: #fff;
    }


@media only screen and (max-width : 768px) {
  #woListing ul li img {
    padding-top: 40px;
  }

    #woListing ul li {
      font-size: 11px;
      background-position: 10px center;
      padding: 10px 0 10px 30px;
    }

    #woListing ul li .woTopRow {
      font-size: 13px;
    }

    #woListing ul li.completedtrue {
      background-image: url(../../static/img/icon-wo-closed.png) !important;
      background-color: #333 !important;
      background-repeat: no-repeat !important;
      background-position: 10px center !important;
      border-left: 8px solid #006600 !important;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000 !important;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00 !important;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900 !important;
    }

  .mobileBottomBar {
    background: #fff;
    position: fixed;
    bottom: 0px;
    display: block;
    z-index: 2;
    width: 100%;
    text-align: center;
    cursor: pointer;
    padding-top: 00px;
     -webkit-box-shadow: 0px -3px 5px #666;
    -moz-box-shadow:    0px -3px 5px #666;
    box-shadow:         0px -3px 5px #666;
    font-family: 'open_sanssemibold';
    font-size: 15px;
    color: #999;
  }

  .mobileBottomBar .col-xs-4 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .mobileBottomBar .center {
    border-left: 2px solid #ddd;
    border-right: 2px solid #ddd;
  }

  .mobileBottomBar span {
    display: block;
    font-size: 12px;
  }

  .mobile-sort {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    max-width: 75%;
    min-width: 50%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
  }

    .mobile-sort h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-sort p {
      display: block;
      margin: 0;
      padding: 10px 0;
      border-bottom: 1px solid #ddd;
    }

    .mobile-sort p:last-of-type {
      border-bottom: 0px;
    }

    .mobile-sort p a {
    display: block;
    color: #333;
    text-decoration: none;
    font-family: 'open_sanssemibold';
    }

    .mobile-sort p a.active {
      font-family: 'open_sansbold';
      text-transform: uppercase;
    }

  .mobile-search {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 90%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
    font-family: 'open_sansbold';
  }

    .mobile-search h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-search input {
    margin-bottom: 20px;
    text-align: center;
    }

    .mobile-search a.btn {
      font-family: 'open_sansbold' !important;
      font-size: 16px;
      color: #fff;
      text-transform: uppercase;
    }

}

.full-box {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 5;
}

  .full-box .loadingWorkOrders {
    margin-top: 100px;
  }

  .full-box .main-logo {
    max-width: 150px;
  }

  .form-control.small{
 width: 60px;
 display: inline-block;
 text-align: center;
}

.innerWOListing li .top-row {
  font-size: 13px;
 text-transform: uppercase;
}

.innerWOListing li {
  font-size: 12px;
}

.innerWOListing li .actions {
  float: right;
  font-size: 21px;
}

.innerWOListing li .actions div {
  display: inline-block;
}

.innerWOListing li .actions i {
  margin: 0 0 0 10px;
}

.innerWOListing li .actions i:hover {
  cursor: pointer;
}

.statusMSG {
  text-align: center;
  font-size: 15px;
}

.edit-box {
  background: #fff;
  -webkit-border-radius: 10px;
-moz-border-radius: 10px;
border-radius: 10px;
max-width: 500px;
margin: 30px auto 0;
padding-bottom: 20px;
}

.lem-formTop {
  background: #f8f8f8;
  padding: 15px;
  text-align: center;
}

.lem-formTop input,
.lem-formTop select {
  text-align: center;
}

.lem-formTop .form-control.small{
 width: 30px;
 display: inline-block;
 text-align: center;
 padding: 6px 0;
}

 .lem-formTop h2 {
      margin: 0;
      padding: 10px 0;
      font-size: 20px;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .lem-formTop .btn {
      border: 0;
      color: #fff;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
         margin-top: 25px;
        display: block;
        width: 100%;
    }

.lem-dividingCount {
  padding: 5px 0;
  text-align: center;
  font-family: 'open_sanssemibold';
  color: #fff;
  background: #333;
  text-transform: uppercase;
}

.el-select, .el-input {
    width: 100%;
    font-size: 12px;
  }

.el-input-number--small {
  width: 100%;
}


</style>


// WEBPACK FOOTER //
// Photos.vue?37262b64